import React from 'react';

const UcsBallotVotingImage: React.FC = () => {
  return (
    <svg
      width="51px"
      height="55px"
      viewBox="0 0 51 55"
      version="1.1"
      data-testid="svg-image"
    >
      <defs>
        <polygon
          id="path-1"
          points="0 78.944 77.961 78.944 77.961 0 0 0"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="UCS---Ballots-&amp;-Voting"
          transform="translate(-399.000000, -89.000000)"
        >
          <g transform="translate(386.000000, 77.000000)">
            <mask id="mask-2" fill="white">
              <use href="#path-1"></use>
            </mask>
            <g id="mask"></g>
            <g id="elections" mask="url(#mask-2)">
              <g transform="translate(13.000000, 12.000000)">
                <path
                  d="M50.9772677,22.8039453 C50.9715046,22.7416406 50.9591246,22.6800879 50.9404479,22.6204688 C50.9184627,22.5613867 50.8901807,22.5049902 50.8561357,22.4520313 C50.8414078,22.4170117 50.8243319,22.382959 50.8051215,22.3500879 L40.7873425,9.51671875 C40.6146627,9.29564453 40.3507336,9.16663086 40.0713295,9.16673828 L37.3391885,9.16673828 L37.3391885,2.75 C37.3375877,1.23191406 36.1152748,0.00161132813 34.6070476,0 L16.3928457,0 C14.8846185,0.00161132813 13.6623056,1.23191406 13.6607048,2.75 L13.6607048,9.16663086 L10.9285638,9.16663086 C10.6491597,9.16652344 10.3852306,9.29564453 10.2126575,9.51661133 L0.194771767,22.3499805 C0.175561401,22.3827441 0.15848552,22.4167969 0.143757573,22.4519238 C0.0727859425,22.556123 0.0309500342,22.6777246 0.0226255423,22.8038379 C0.0125934622,22.8408984 0.00501604003,22.8786035 0,22.9166309 L0,27.5 C0.00117396682,28.5120215 0.815906936,29.3321875 1.82146288,29.3333691 L1.82146288,52.25 C1.82306374,53.7680859 3.04537664,54.9983887 4.55360383,55 L46.4463962,55 C47.9546234,54.9983887 49.1769363,53.7680859 49.1785371,52.25 L49.1785371,29.3333691 C50.1839863,29.3321875 50.998826,28.5121289 51,27.5 L51,22.9166309 C50.9948772,22.8786035 50.9872998,22.8408984 50.9772677,22.8039453 Z M37.3391885,15.5833691 L37.7945809,15.5833691 L39.1606514,17.4167383 L37.3391885,17.4167383 L37.3391885,15.5833691 Z M15.4820609,2.75 C15.4825945,2.24393555 15.8900677,1.83379883 16.392739,1.83336914 L34.6070476,1.83336914 C35.1098255,1.83390625 35.5172987,2.24393555 35.5177256,2.75 L35.5177256,17.4166309 L15.4820609,17.4166309 L15.4820609,2.75 Z M11.3710426,11 L13.6607048,11 L13.6607048,13.75 L12.7500267,13.75 C12.4633653,13.75 12.193353,13.8859961 12.0216336,14.1170605 L9.28949268,17.7836914 C9.08244763,18.061377 9.04904293,18.4329492 9.20336621,18.7435059 C9.35758276,19.0540625 9.67305966,19.2501074 10.0179925,19.25 L40.982221,19.25 C41.3271538,19.2501074 41.642524,19.0540625 41.7968472,18.7435059 C41.9510638,18.4329492 41.9177658,18.061377 41.7107208,17.7836914 L38.9785798,14.1170605 C38.8068605,13.8859961 38.5368481,13.75 38.2501868,13.75 L37.3395087,13.75 L37.3395087,11 L39.6291709,11 L48.2156709,22 L2.78443584,22 L11.3710426,11 Z M13.6607048,15.5833691 L13.6607048,17.4167383 L11.8392419,17.4167383 L13.2053124,15.5833691 L13.6607048,15.5833691 Z M47.3570742,52.25 C47.3565406,52.7560645 46.9491741,53.1662012 46.4463962,53.1666309 L4.5534971,53.1666309 C4.05071913,53.1660938 3.64324592,52.7560645 3.64281903,52.25 L3.64281903,29.3333691 L24.5892686,29.3333691 L26.4107314,29.3333691 L47.3570742,29.3333691 L47.3570742,52.25 Z M48.2677523,27.5 L26.4106247,27.5 L24.5892686,27.5 L1.82135615,27.5 L1.82135615,23.8333691 L49.178964,23.8333691 L49.1798178,27.5 L48.2677523,27.5 Z"
                  id="Shape"
                  stroke="none"
                  fill="#333E48"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M25.5624794,9 L33.4375206,9 C33.7481927,9 34,8.55232626 34,8 C34,7.44767374 33.7481927,7 33.4375206,7 L25.5624794,7 C25.2518073,7 25,7.44767374 25,8 C25,8.55232626 25.2518073,9 25.5624794,9 Z"
                  id="Shape"
                  stroke="none"
                  fill="#333E48"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M25.5624794,17 L33.4375206,17 C33.7481927,17 34,16.5523263 34,16 C34,15.4476737 33.7481927,15 33.4375206,15 L25.5624794,15 C25.2518073,15 25,15.4476737 25,16 C25,16.5523263 25.2518073,17 25.5624794,17 Z"
                  id="Shape-Copy"
                  stroke="none"
                  fill="#333E48"
                  fillRule="nonzero"
                ></path>
                <rect
                  id="Rectangle-3"
                  stroke="#333E48"
                  strokeWidth="1.5"
                  fill="#F9BE00"
                  fillRule="evenodd"
                  x="18.75"
                  y="5.75"
                  width="4.5"
                  height="4.5"
                  rx="1"
                ></rect>
                <rect
                  id="Rectangle-3-Copy"
                  stroke="#333E48"
                  strokeWidth="1.5"
                  fill="none"
                  x="18.75"
                  y="13.75"
                  width="4.5"
                  height="4.5"
                  rx="1"
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default UcsBallotVotingImage;
